import React from "react";
import classNames from "classnames";
import { WrapperProps } from "./types";
import "./styles.scss";

const Wrapper: React.FC<WrapperProps> = (props) => {
  const classnames = classNames(`wrapper`, {
    // size
    [props.className || ""]: props.className,
    [props.classNames || ""]: props.classNames,
    "wrapper--collapse": props.collapse,
    "wrapper--flex": props.flex,
    "wrapper--flexDesktop": props.flexDesktop,
    "wrapper--small": props.small,
    "wrapper--medium": props.medium,
    "wrapper--large": props.large,
    "wrapper--compact": props.compact,
    "wrapper--center": props.center,
    "wrapper--marginTop": props.marginTop,
    "wrapper--paddingTop": props.paddingTop,
    "wrapper--twoCols": props.twoCols,
    "wrapper--isCollapsedMobile": props.isCollapsedMobile,
    "wrapper--rowReverse": props.rowReverse,
    "wrapper--paddingHorizontal":
      props.paddingHorizontal === undefined ? true : props.paddingHorizontal,
    "wrapper--paddingLeft": props.paddingLeft,
  });
  return (
    <>
      <div
        data-testid="wrapper"
        id={props.id}
        key={props.id}
        className={classnames}>
        {props.children}
      </div>
    </>
  );
};

export default Wrapper;
